import { ScToast } from '@intelipost-js/secure-components';
import { Http, GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getWarehouseConfigList({ commit }) {
    commit('toggleLoadingWarehouses', true);

    return GraphQlClient.query(`
      query {
        sefazConfigs {
          configuration_id,
          warehouse_id,
          warehouse_name,
          warehouse_code,
          warehouse_zipcode,
          warehouse_state_code,
          warehouse_federal_tax_id,
          configuration_state,
          configuration_date,
        }
      }`)
      .then(({ data }) => {
        const { sefazConfigs } = data || {};
        commit('setWarehouseConfigs', sefazConfigs);
        commit('toggleLoadingWarehouses', false);
      })
      .catch(() => {
        ScToast.danger('Falha ao buscar os certificados');
        commit('toggleLoadingWarehouses', false);
      });
  },

  uploadCertificateFile({ commit }, uploadForm) {
    commit('toggleModalLoading', 'addCertificate');

    const uploadData = new FormData();
    uploadData.append('certificate', uploadForm.certificateFile.file);
    uploadData.append('clientFederalTaxId', uploadForm.warehouse_federal_tax_id);
    uploadData.append('clientFederalTaxState', uploadForm.warehouse_state_code);
    uploadData.append('clientCertificatePassword', uploadForm.certificatePassword);

    if (uploadForm.updateId) {
      uploadData.append('configurationId', uploadForm.updateId);
    }

    const uploadUrl = `${process.env.GRAPHQL_URL}/api/sefaz/config`;

    return Http.post(uploadUrl, uploadData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .catch(() => ScToast.danger('Falha ao adicionar o certificado'))
    .finally(() => commit('toggleModalLoading', false));
  },

  removeCertificateFile({ commit }, configuration_id) {
    commit('toggleModalLoading', 'removeCertificate');

    return GraphQlClient.mutation(`
      mutation($configuration_id: String!) {
        excludeSefazConfiguration(configuration_id: $configuration_id) {
          result
        }
      }
    `, { configuration_id })
    .catch(() => ScToast.danger('Falha ao excluir o certificado'))
    .finally(() => commit('toggleModalLoading', false));
  },

};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/configuration-sefaz/store/actions.js